"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
var getFacebookLocale = function (language, userLanguage) {
    return constants_1.languageToFacebookLocale[language === 'userLang' ? userLanguage : language] ||
        constants_1.DEFAULT_FACEBOOK_LOCALE;
};
var getSizeWithoutFaces = function (layout, action, locale) {
    var _a;
    var layoutToSize = (_a = {},
        _a[constants_1.LAYOUT_STANDARD] = [
            constants_1.widthForStandardLayoutByAction[action],
            constants_1.heightForStandardLayoutByAction[action],
        ],
        _a[constants_1.LAYOUT_BUTTON_COUNT] = [
            constants_1.widthForButtonCountLayoutByActionAndLocale[action][locale],
            constants_1.heightForButtonCountLayoutByAction[action],
        ],
        _a[constants_1.LAYOUT_BOX_COUNT] = [
            constants_1.widthForBoxCountLayoutByActionAndLocale[action][locale],
            constants_1.heightForBoxCountLayoutByAction[action],
        ],
        _a);
    return layoutToSize[layout];
};
var getSizeWithFaces = function (layout, action) {
    var _a;
    var layoutToSize = (_a = {},
        _a[constants_1.LAYOUT_STANDARD] = [
            constants_1.widthForStandardLayoutByActionWithFaces[action],
            constants_1.heightForStandardLayoutByActionWithFaces[action],
        ],
        _a[constants_1.LAYOUT_BUTTON_COUNT] = [
            constants_1.widthForButtonCountLayoutByActionWithFaces[action],
            constants_1.heightForButtonCountLayoutByActionWithFaces[action],
        ],
        _a[constants_1.LAYOUT_BOX_COUNT] = [
            constants_1.widthForBoxCountLayoutByActionWithFaces[action],
            constants_1.heightForBoxCountLayoutByActionWithFaces[action],
        ],
        _a);
    return layoutToSize[layout];
};
var getSize = function (layout, action, locale, showFaces) {
    var _a = showFaces
        ? getSizeWithFaces(layout, action)
        : getSizeWithoutFaces(layout, action, locale), width = _a[0], height = _a[1];
    return {
        width: width + "px",
        height: height + "px",
    };
};
exports.props = withCompInfo_1.withCompInfo(['compProps', 'language'], function (_a) {
    var _b = _a.compProps, layout = _b.layout, action = _b.action, colorScheme = _b.colorScheme, enableSend = _b.send, showFaces = _b.show_faces, language = _b.language, userLanguage = _a.language;
    return ({
        layout: layout,
        action: action,
        colorScheme: colorScheme,
        enableSend: enableSend,
        showFaces: showFaces,
        locale: getFacebookLocale(language, userLanguage),
        socialUrl: '',
    });
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'language'], function (_a) {
    var _b = _a.compProps, layout = _b.layout, showFaces = _b.show_faces, action = _b.action, language = _b.language, userLanguage = _a.language;
    var locale = getFacebookLocale(language, userLanguage);
    return getSize(layout, action, locale, showFaces);
});
//# sourceMappingURL=WFacebookLike.js.map